
const initialState = {
    login: { err: {}, msg: [] },
    register: { err: {}, msg: [] },
    changePassword: { err: {}, msg: [] },
    invoice: { err: {}, msg: [] },
    user: { err: {}, msg: [] },
    profile: { err: {}, msg: [] },
    customer: { err: {}, msg: [] },
};

const errorsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_ERRORS": {
            const { namespace, payload } = action;
            console.log('errorsReducer', namespace, payload)
            return {
                ...state,
                [namespace]: payload,
            };
        }
        case "CLEAR_ERRORS": {
            const { namespace } = action;
            return {
                ...state,
                [namespace]: { err: {}, msg: [] },
            };
        }
        default:
            return state;
    }
};

export default errorsReducer;
